// This is just an example,
// so you can safely delete all default props below

export default {
    back: 'Tilbake',
    title: 'Krav',
    create: 'Opprett',
    claim: 'Krav',
    new_claim: 'Opprett nytt krav',
    claim_type: 'Krav type',
    claim_value: 'Krav verdi',
    delete: 'Slett',
    save: 'Lagre',
    create_child_claim: 'Opprett underkrav',
    create_child_claim_for: 'Opprett underkrav for',
}